import React from 'react'
import './ProductsTitle.css'

export default function ProductsTitle() {
  return (
    <section className="products-section">

      <div className="arrow-left">≫</div>

      <div className="products-content">

        <h1>Products</h1>

        <div className="wave-divider">
          ~
        </div>

        <p>
          Explore our innovative range of products designed to address your unique needs, 
          from powerful software solutions to user-friendly digital applications that 
          enhance efficiency and productivity. Discover how our customized tools can help 
          you achieve your goals, streamline operations, and create a seamless digital 
          experience while driving growth and success. This page showcases our products, 
          their features and benefits, alongside logos of companies we have developed 
          customized solutions for, reflecting our expertise and the trust our clients 
          place in us.
        </p>

      </div>

      <div className="arrow-right">≫</div>

    </section>
  )
}